module.exports = __webpack_public_path__ + "img/button_on.ddf4e41d.png";